import { getAppInstance } from '/@/store/session/selectors';
import { localeSort } from '/@/utils';

export const getWeedsRecommendationEnabled = (state) => getAppInstance(state).enableWeedsRecommendation;

export const getWeedSystemChoicesOptions = (weedsControlPlans, language, weedSystems) => {
    const weedsSystemChoices = getWeedSystemChoices(weedsControlPlans, weedSystems);

    if (weedsSystemChoices.length === 0) return [];

    return weedsSystemChoices.map((weedSystemChoice) => ({
        value: weedSystemChoice.id,
        label: `${weedSystemChoice.secondaryCrop[language]} / ${weedSystemChoice.mainCrop[language]}`,
    }));
};

const getWeedSystemChoices = (weedsSystemChoices, weedSystems) => {
    const systemIds = new Set();
    weedsSystemChoices.forEach((controlPlan) => controlPlan.systems.forEach((systemId) => systemIds.add(systemId)));

    return weedSystems
        .filter((system) => systemIds.has(system.id))
        .sort((a, b) => a.order - b.order || localeSort('name')(a, b));
};
